function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Events } from '../utils/events';
const DEFAULT_OPTIONS = {
  scrollableElement: null,
  scrollThreshold: 100,
  scrollMaxSpeed: 15,
  moveInFromOutsideTimeout: 300
};
function getDocumentScrollingElement() {
  return document.scrollingElement || document.documentElement;
}
export default class Autoscroll {
  get options() {
    let options = this.modifierInstance.named.pluginOptions?.autoscroll ?? {};
    return Object.assign({}, DEFAULT_OPTIONS, options);
  }
  findScrollableElement() {
    let {
      scrollableElement
    } = this.options;
    if (typeof scrollableElement === 'string') {
      return document.querySelector(scrollableElement);
    } else if (scrollableElement instanceof HTMLElement) {
      return scrollableElement;
    } else if (typeof scrollableElement === 'function') {
      return scrollableElement(this.element);
    } else {
      return getDocumentScrollingElement();
    }
  }
  constructor(modifierInstance) {
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "modifierInstance", void 0);
    _defineProperty(this, "scrollableElement", null);
    _defineProperty(this, "scrollableElementFrame", null);
    _defineProperty(this, "animationFrame", null);
    _defineProperty(this, "mousePosition", {
      x: 0,
      y: 0
    });
    _defineProperty(this, "startedOutside", false);
    _defineProperty(this, "outsideStartTimestamp", 0);
    this.element = modifierInstance.draggableElement;
    this.modifierInstance = modifierInstance;
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragMove = this.onDragMove.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.performScroll = this.performScroll.bind(this);
  }
  attach() {
    this.element.addEventListener(Events.DragStart, this.onDragStart);
    this.element.addEventListener(Events.DragMove, this.onDragMove);
    this.element.addEventListener(Events.DragEnd, this.onDragEnd);
  }
  detach() {
    this.element.removeEventListener(Events.DragStart, this.onDragStart);
    this.element.removeEventListener(Events.DragMove, this.onDragMove);
    this.element.removeEventListener(Events.DragEnd, this.onDragEnd);
    this.onDragEnd();
  }
  onDragStart() {
    this.scrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.findScrollableElement();
    });
  }
  onDragMove(event) {
    this.animationFrame = requestAnimationFrame(this.performScroll);
    this.mousePosition = {
      x: event.detail.clientX ?? 0,
      y: event.detail.clientY ?? 0
    };
  }
  onDragEnd() {
    if (this.scrollableElementFrame) {
      cancelAnimationFrame(this.scrollableElementFrame);
    }
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    this.startedOutside = false;
  }
  performScroll() {
    let {
      scrollableElement,
      mousePosition,
      options
    } = this;
    if (!scrollableElement || !mousePosition) {
      return;
    }
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    let {
      x,
      y
    } = mousePosition;
    let edgeDistances = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
    if (scrollableElement !== document.body && scrollableElement !== document.documentElement) {
      let rect = scrollableElement.getBoundingClientRect();
      edgeDistances.top = y - rect.top;
      edgeDistances.bottom = rect.height - edgeDistances.top;
      edgeDistances.left = x - rect.left;
      edgeDistances.right = rect.width - edgeDistances.left;
    } else {
      edgeDistances.top = y;
      edgeDistances.bottom = window.innerHeight - edgeDistances.top;
      edgeDistances.left = x;
      edgeDistances.right = window.innerWidth - edgeDistances.left;
    }
    if (edgeDistances.top < 0 || edgeDistances.right < 0 || edgeDistances.bottom < 0 || edgeDistances.left < 0) {
      this.startedOutside = true;
      this.outsideStartTimestamp = new Date().getTime();
      this.animationFrame = requestAnimationFrame(this.performScroll);
      return;
    }
    if (this.startedOutside) {
      let currentTimestamp = new Date().getTime();
      if (currentTimestamp - this.outsideStartTimestamp < options.moveInFromOutsideTimeout) {
        this.animationFrame = requestAnimationFrame(this.performScroll);
        return;
      }
    }
    if (edgeDistances.top < options.scrollThreshold) {
      let percentageOfThreshold = (options.scrollThreshold - edgeDistances.top) / options.scrollThreshold;
      scrollableElement.scrollTop -= options.scrollMaxSpeed * percentageOfThreshold;
    } else if (edgeDistances.bottom < options.scrollThreshold) {
      let percentageOfThreshold = (options.scrollThreshold - edgeDistances.bottom) / options.scrollThreshold;
      scrollableElement.scrollTop += options.scrollMaxSpeed * percentageOfThreshold;
    }
    if (edgeDistances.left < options.scrollThreshold) {
      let percentageOfThreshold = (options.scrollThreshold - edgeDistances.left) / options.scrollThreshold;
      scrollableElement.scrollLeft -= options.scrollMaxSpeed * percentageOfThreshold;
    } else if (edgeDistances.right < options.scrollThreshold) {
      let percentageOfThreshold = (options.scrollThreshold - edgeDistances.right) / options.scrollThreshold;
      scrollableElement.scrollLeft += options.scrollMaxSpeed * percentageOfThreshold;
    }
    this.animationFrame = requestAnimationFrame(this.performScroll);
  }
}